<script setup lang="ts">
import { useArticle } from '~/composables/useArticle';
import { Article } from '~/types';
import VLazyImage from 'v-lazy-image';
import { useVideoPopupStore } from '~/stores/useVideoPopupStore';
import { Link } from '@inertiajs/vue3';

interface Props {
  article: Article.Model;
}

const props = defineProps<Props>();

const videoPopupStore = useVideoPopupStore();

const { permalink, title, video, articleDate } = useArticle(props.article);
</script>

<template>
  <div class="latest-posts__item">
    <div class="latest-posts__thumb latest-posts__thumb--with-video">
      <button type="button" @click.prevent="videoPopupStore.setArticle(article)">
        <VLazyImage :src="video?.poster_url" :alt="video?.title" />
        <span class="play-button"></span>
      </button>
    </div>
    <div class="latest-posts__meta">
      <span class="latest-posts__tagline">
        <time>{{ articleDate }}</time>
      </span>
      <h3>
        <Link :href="permalink">{{ title }}</Link>
      </h3>
    </div>
  </div>
</template>
